import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroAirwallexBatchPaymentForm.BillsInformation', {
    emptyText: 'No bills added to Airwallex Batch Payment',
});

export const messagesConfig = defineMessages(
    'pages.RequestFormPage.XeroAirwallexBatchPaymentForm.BillsInformation.tableConfig',
    {
        itemName: 'Bill',
        billCurrency: 'Bill currency',
        paymentFee: 'Fee',
        beneficiary: 'Beneficiary',
        dateName: 'Date',
        dueDateName: 'Due Date',
        amountDueName: 'Amount Due',
        paymentReference: 'Payment reference',
        paymentMethod: 'Payment method',
        sourceCurrency: 'Source currency',
        xeroBankAccount: 'Xero bank account',
        paymentAmount: 'Payment amount',
        menuItemRemove: 'Remove',
        attachments: 'Attachments',
        paymentPurpose: 'Purpose',
        no2FA: 'You need to enable 2FA in profile settings first.',
        beneficiaryPlaceholder: 'Select beneficiary',
        addBeneficiaryButton: '+ New Beneficiary',
        paymentMethodPlaceholder: 'Select payment method',
        feePlaceholder: 'Select fee option',
        currencyPlaceholder: 'Select currency',
        purposePlaceholder: 'Select purpose',
        bankAccountPlaceholder: 'Select bank account',
        swift: 'Swift',
        local: 'Local',
    }
);
